import { ContentCardProps, ContentType } from 'learning-panel-components';
import { getTags } from 'utils';

const convertLessonToContentCard = (lesson: any, isLeanUser: boolean, onContactUsClick: Function): ContentCardProps => {
    return {
        uuid: lesson.uuid,
        type: 'lesson' as keyof typeof ContentType,
        imageUrl: lesson.iconUrl ?? `${process.env.PUBLIC_URL}/images/lessonDefaultCard.webp`,
        name: lesson.name,
        displayName: lesson.displayName,
        description: lesson.description,
        timeOrDate: lesson.duration,
        cardUrl: lesson.url,
        links: getTags(lesson),
        tags: lesson.tags?.map((tag: any) => tag.displayName),
        useOverlay: Boolean(lesson.iconUrl),
        status: lesson.isCompleted ? 'completed' : 'notStarted',
        isLeanDisabled: isLeanUser && !lesson.activeOnLean,
        earnedPoints: lesson.earnedPoints,
        doneRecently: lesson.doneRecently,
        score: lesson.doneRecently ? undefined : lesson.potentialPoints,
        onContactUsClick: isLeanUser ? onContactUsClick : undefined,
        dueDate: lesson.dueDate ? new Date(lesson.dueDate) : undefined,
        systemCourseDisplayName: lesson.systemCourseDisplayName,
        customCourseDisplayNames: lesson.customCourseDisplayNames,
        tagsNames: lesson.tags?.map((tag: any) => tag.name)
    };
};

export default convertLessonToContentCard;
